'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/banner.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _messageBase = require('./message-base');
var _messageBase2 = _interopRequireDefault(_messageBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var TrustPilot = function (_Component) {
  _inherits(TrustPilot, _Component);
  function TrustPilot(props) {
    _classCallCheck(this, TrustPilot);
    var _this = _possibleConstructorReturn(this, (TrustPilot.__proto__ || Object.getPrototypeOf(TrustPilot)).call(this, props));
    _this.state = {
      highestRatingScore: 5,
      score: 5,
      stars: 0,
      total: '...',
      ratingString: '',
      product: ''
    };
    return _this;
  }
  _createClass(TrustPilot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;
      _axios2.default.get(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/trustpilot-score' + (this.props.product ? '?product=' + this.props.product : '')).then(function (response) {
        return _this2.setState(Object.assign({}, response.data.data));
      });
    }
  }, {
    key: 'message',
    value: function message() {
      return _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        },
        __self: this
      }, 'Marmalade ', this.state.product ? this.state.product + ' ' : '', 'is rated', ' ', this.state.ratingString ? _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33
        },
        __self: this
      }, this.state.ratingString, ' by', ' ', _react2.default.createElement('a', {
        href: 'https://www.trustpilot.com/review/wearemarmalade.co.uk',
        rel: 'nofollow noopener noreferrer',
        target: '_blank',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }, 'Trust Pilot'), ' ', 'based on', ' ') : this.state.score + '/' + this.state.highestRatingScore + ' from ', this.state.total, ' reviews.');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_messageBase2.default, {
        stars: this.state.stars,
        message: this.message(),
        backgroundColor: '#233342',
        padding: '7px 0',
        color: 'white',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54
        },
        __self: this
      });
    }
  }]);
  return TrustPilot;
}(_react.Component);
exports.default = TrustPilot;